import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { UcBreadcrumb } from "../components/UcBreadcrumb";
import { UcCategories } from "../components/UcCategories";
import { UcExplainer } from "../components/UcExplainer";
import { UnitConverter } from "../components/UnitConverter";
import { getCategory } from "../lib/units";

export function UnitConverterHub() {
  const length = getCategory("length");
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <UcBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.uc_hub_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.uc_hub_intro()}
          </p>
        </header>

        {length && <UnitConverter category={length} />}

        <UcCategories />

        <UcExplainer
          howTo={m.uc_hub_howto()}
          faqs={[
            { q: m.uc_hub_faq1_q(), a: m.uc_hub_faq1_a() },
            { q: m.uc_hub_faq2_q(), a: m.uc_hub_faq2_a() },
            { q: m.uc_hub_faq3_q(), a: m.uc_hub_faq3_a() },
            { q: m.uc_hub_faq4_q(), a: m.uc_hub_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
